class PictureStack {
	/**
	 * @param {Node} container
	 * @param {Object[]} cocktails
	 * @param {Node} scrollBackEl
	 */
	constructor(container) {
		this.container = container
		this.innerContainer = container.querySelector('.picture-stack__inner')
		this.slides = container.querySelectorAll('.picture-stack__slide')
		this.paginationItems = this._createPaginationItems()
		this.controlBtns = this._createControlBtns()
		this.activeSlide = this.slides.length - 1

		this.showSlide(this.activeSlide)
		this._updateBtns()
		this._updatePagination()

		this._updateHeight()
		window.addEventListener('resize', () => this._updateHeight())
	}

	_createPaginationItems() {
		const pagination = this.container.querySelector('.picture-stack__pagination')
		const items = []

		for (let i = this.slides.length - 1; i >= 0; i--) {
			const item = document.createElement('span')
			item.className = 'picture-stack__pagination-item'

			items.push(item)
			pagination.appendChild(item)

			item.addEventListener('click', () => {
				this.showSlide(i)
			})
		}

		return items.reverse()
	}

	_createControlBtns() {
		const controlsContainer = this.container.querySelector('.picture-stack__controls')
		if (!controlsContainer) return

		const SwipeZone = window.app.SwipeZone

		const prev = document.createElement('span')
		const next = document.createElement('span')

		controlsContainer.appendChild(prev)
		controlsContainer.appendChild(next)

		prev.addEventListener('click', () => this.prevSlide())
		next.addEventListener('click', () => this.nextSlide())

		const swipeZone = new SwipeZone(controlsContainer, '10%')
		swipeZone.onLeft(() => {
			controlsContainer.classList.add('hidden')
			this.nextSlide()
		})
		swipeZone.onRight(() => {
			controlsContainer.classList.add('hidden')
			this.prevSlide()
		})

		return { prev, next }
	}

	_updateHeight() {
		const slideHeights = [...this.slides].map(it => it.getBoundingClientRect().height)
		this.innerContainer.style.height = Math.max(...slideHeights) + 'px'
	}

	_updatePagination() {
		this.paginationItems.forEach((it, index) => {
			if (this.activeSlide === index) {
				it.classList.add('active')
			} else {
				it.classList.remove('active')
			}
		})
	}

	_updateBtns() {
		if (this.activeSlide === 0) {
			this.controlBtns.next.classList.add('hidden')
			this.controlBtns.prev.classList.remove('hidden')
		} else if (this.activeSlide === this.slides.length - 1) {
			this.controlBtns.prev.classList.add('hidden')
			this.controlBtns.next.classList.remove('hidden')
		} else {
			this.controlBtns.prev.classList.remove('hidden')
			this.controlBtns.next.classList.remove('hidden')
		}
	}

	showSlide(slideIndex) {
		if (slideIndex > this.slides.length - 1) return

		this.slides.forEach((slide, i) => {
			if (i === slideIndex) {
				slide.classList.add('active')
				slide.classList.remove('prev')
			} else if (i > slideIndex) {
				slide.classList.add('prev')
				slide.classList.remove('active')
			} else {
				slide.classList.remove('prev')
				slide.classList.remove('active')
			}
		})

		this.activeSlide = slideIndex

		this._updateBtns()
		this._updatePagination()
	}

	prevSlide() {
		if (this.activeSlide + 1 === this.slides.length) return
		this.showSlide(this.activeSlide + 1)
	}

	nextSlide() {
		if (this.activeSlide === 0) return
		this.showSlide(this.activeSlide - 1)
	}
}

const pictureStacks = document.querySelectorAll('.picture-stack')
for (const pictureStack of pictureStacks) {
	new PictureStack(pictureStack)
}
